
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  create_cart_api,
  get_cart_api,
  update_cart_api,
} from "../../Config/API";

const initialState = {
  items: [],
  totalQuantity: 0,
  status: "idle",
  error: null,
};

// Thunk to fetch cart data from the database
export const fetchCart = createAsyncThunk(
  "cart/fetchCart",
  async (payload, thunkAPI) => {
    try {
      const response = await get_cart_api(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch cart."
      );
    }
  }
);

// Thunk to add a new product to the cart
export const createCart = createAsyncThunk(
  "cart/createCart",
  async ({ user_id, items }, thunkAPI) => {
    try {

      //  console.log("userid",user_id);
      //  console.log("items",items);
      const payload = {
        user_id: user_id,
        items: items,
        totalQuantity: 1,
      };
      const response = await create_cart_api(payload);
      // console.log("response",response.data)
      return response.data; // Assume response contains the newly created cart item
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to add product to cart."
      );
    }
  }
);

// Thunk to update an existing product in the cart
export const updateCart = createAsyncThunk(
  "cart/updateCart",
  async ({ user_id, items, quantity }, thunkAPI) => {
    try {
      console.log("items" ,items)
      const payload = {
        user_id: user_id,
        items: items,
        totalQuantity: quantity,
      };
      const response = await update_cart_api(payload);
      // console.log("response",response.data)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to update cart."
      );
    }
  }
);

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const product = action.payload;

      // Check if the product already exists in the cart
      const existingItem = state.items.find(
        (item) => item.product_id === product.uuid
      );

      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        state.items.push({
          ...product,
          quantity: 1,
        });
      }

      // Update cart totals
      state.totalQuantity += 1;
    },
    removeFromCart: (state, action) => {
      const productId = action.payload;

      const existingItem = state.items.find(
        (item) => item.product_id === productId
      );
      if (existingItem) {
        state.totalQuantity -= existingItem.quantity;

        // Remove the item from the cart
        state.items = state.items.filter(
          (item) => item.product_id !== productId
        );
      }
    },
    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Cart
      .addCase(fetchCart.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        // console.log("action",action)
        state.items = action.payload.items || [];
        state.totalQuantity = action.payload.totalQuantity || 0;
      })
      .addCase(fetchCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Create Cart
      .addCase(createCart.fulfilled, (state, action) => {
        console.log("action",action)
        const product = action?.payload?.items[0];
      
        const existingItem = state.items.find(
          (item) => item.product_id === product.uuid
        );

        if (!existingItem) {
          state.items.push({ ...product, quantity: 1 });
          state.totalQuantity += 1;
        }
      })
      .addCase(createCart.rejected, (state, action) => {
        state.error = action.payload;
      })
      // Update Cart
      .addCase(updateCart.fulfilled, (state, action) => {
        // console.log("action",action)
        state.items = action?.payload[0].items || [];
        state.totalQuantity = action?.payload[0].totalQuantity || 0;
      })
      .addCase(updateCart.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearCart, addToCart, removeFromCart } = cartSlice.actions;

export default cartSlice.reducer;
